// 商品中心
import qs from 'qs'
export default {
    saveExtendInfoForStoredim: (params) =>
        $network.post('/api/cs/md/storedim/saveExtendInfo', params), // 门店&逻辑仓档案defined表单 - 保存
    getExtendInfoForStoredim: (params) =>
        $network.get(`/api/cs/md/storedim/getExtendInfo?${qs.stringify(params)}`), // 门店&逻辑仓档案defined表单 - 获取
    saveExtendInfoForSuppdim: (params) =>
        $network.post('/api/cs/md/suppdim/saveExtendInfo', params), // 供应商defined表单 - 保存
    getExtendInfoForSuppdim: (params) =>
        $network.get(`/api/cs/md/suppdim/getExtendInfo?${qs.stringify(params)}`), // 供应商defined表单 - 获取
    saveExtendInfoForCustomer: (params) =>
        $network.post('/api/cs/md/saveExtendInfo', params), // 客户档案defined表单 - 保存
    getExtendInfoForCustomer: (params) =>
        $network.get(`/api/cs/md/getExtendInfo?${qs.stringify(params)}`), // 客户档案defined表单 - 获取
    saveExtendInfo: (params) =>
        $network.post('/api/cs/md/shop/saveExtendInfo', params), // 平台店铺档案- 扩展字段信息 - 保存
    saveExtendInfoForGoods: (params) =>
        $network.post('/api/cs/md/goods/saveExtendInfo', params), // 商品SPU- 扩展字段信息 - 保存
    getExtendInfo: (params) =>
        $network.get(`/api/cs/md/shop/getExtendInfo?${qs.stringify(params)}`), // 平台店铺档案- 扩展字段信息 - 获取
    getExtendInfoForGood: (params) =>
        $network.get(`/api/cs/md/goods/getExtendInfo?${qs.stringify(params)}`), // 商品SPU- 扩展字段信息 - 获取
    selectSkuProBySkuEcodeList: (params) =>
        $network.post('/p/cs/md/pro//v1/selectSkuProBySkuEcodeList', params), // 零售发货单》批量添加商品查询接口
    skuGroupSave: (params) => $network.post('/api/cs/md/product/skuGroupSave', params), // 新增页保存
    skuGroupDelDetail: (params) =>
        $network.post('/api/cs/md/product/skuGroupDelDetail', params), // 条码明细删除
    skuGroupSubmit: (params) =>
        $network.post('/api/cs/md/product/skuGroupSubmit', params), // 提交
    skuGroupVoid: (params) => $network.post('/api/cs/md/product/skuGroupVoid', params), // 作废
    skuPage: (params) => $network.post('/api/cs/md/product/skuPage', params), // 触发分页
    skuGroupDetailSearch: (params) =>
        $network.post('/api/cs/md/product/skuGroupDetailSearch', params), // 分页请求数据
    skuGroupEditorSearch: (params) =>
        $network.post('/api/cs/md/product/skuGroupEditorSearch', params), // 初始化数据
    getCodeAndParam: (params) => $network.post('/api/cs/md/product/getCodeAndParam', params),
    /* 2.0: */
    operateSku: (params) => $network.post('/p/cs/md/sku/v1/operateSku', params), // 商品SKU-保存
    querySpu: (params) => $network.post('/p/cs/md/pro/v1/querySpu', params), // 查询spu档案
    queryAttributeSku: (params) =>
        $network.post('/p/cs/md/sku/v1/queryAttributeSku', params), // 查询spu/sku自定义属性
    listSku: (params) => $network.post('/p/cs/md/pro/v1/list/sku', params),
    listSpu: (params) => $network.post('/p/cs/md/pro/v1/list/sup', params),
    spuSave: (params) => $network.post('/p/cs/md/pro/v1/save', params), // spu档案保存
    querySku: (params) =>
        $network.post('/p/cs/md/pro/group/v1/skuGroupLikeSelect', params), // SKU编码查询
    // skuGroupSave: (params) =>
    //   $network.post('/p/cs/md/pro/group/v1/skuGroupSave', params), // 组合商品保存接口
    selectGroupById: (params) =>
        $network.post('/p/cs/md/pro/group/v1/selectGroupById', params), // 组合商品查询
    skuGroupDelItem: (params) =>
        $network.post('/p/cs/md/pro/group/v1/skuGroupDelItem', params), // 组合商品明细删除
    cusAttrSave: (params) => $network.post('/p/cs/md/attribute/v1/save', params), // 商品自定义属性-保存
    queryClassifyInit: (params) =>
        $network.post('/p/cs/md/pro/classify/v1/queryClassify', params), // 商品分类-初始化查询
    saveClassify: (params) =>
        $network.post('/p/cs/md/pro/classify/v1/saveClassify', params), // 商品分类-保存
    queryClassifyItem: (params) =>
        $network.post('/p/cs/md/pro/classify/v1/queryClassifyItem', params), // 商品分类-子表-添加
    delClassifyItem: (params) =>
        $network.post('/p/cs/md/pro/classify/v1/delClassifyItem', params), // 商品分类-子表-删除
    treeLoad: (params) => $network.post('/p/cs/md/spec/v1/load', params), // spu快速生成查询树
    quickAdd: (params) => $network.post('/p/cs/md/sku/v1/quick/add', params), // 快速生成接口
    skuSelSpecobj: (params) =>
        $network.post('/p/cs/md/sku/v1/selSpecobj', params), // 商品sku-新增/详情-规格维度一、二等下拉查询及模糊查询

    queryClassifyTree: (params) =>
        $network.post('/p/cs/md/pro/classify/v1/queryClassifyTree', params), // 商品分类-列表-树结构
    downloadRealSkuGroupTemp: (params) =>
        $network.post('/api/cs/md/product/downloadRealSkuGroupTemp', params), // 组合商品档案明细与虚拟条码下载模板
    downloadSkuGroupTemp: (params) =>
        $network.post('/api/cs/md/product/downloadSkuGroupTemp', params), // 组合商品明细下载模板
    syncProFromDw: (params) =>
        $network.post('/p/cs/syncProFromDw', params), // 组合商品明细下载模板
    exportSkuGroup: (params) => $network.post('/api/cs/md/product/exportSkuGroup', params), // 组合商品明细-导出
}
